import React, { useState, useEffect, useContext } from 'react';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { PdpSummaryViewComponent } from 'atoms/PdpSummary/Presentation/PdpSummaryViewComponent';
import { QuantityModifier } from 'molecules/QuantityModifier';
import Non_veg_dot_Icon from 'styles/staticAssets/images/Non_veg_dot_Icon.svg';
import Veg_dot_Icon from 'styles/staticAssets/images/Veg_dot_Icon.svg';
import PDPEditIcon from 'styles/staticAssets/images/PDPEditIcon.svg';
import PDPEditIconDisabled from 'styles/staticAssets/images/PDPEditIconDisabled.svg';
import {
  isMobileDevice,
  getPriceBasedOnShowPriceWithTaxFlag,
  isEmptyObject,
  getAndCheck,
  getTernaryValue,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { MENU_PDP_PAGE_CONSTANTS } from '../../Constants/MenuPDPPageConstants';
import MENU_CONSTANT from 'organisms/GenericMenuCategories/MenuConstants/MenuConstants';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { useDispatch, useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { addItemToCartAction } from '@kfc-global/react-shared/redux/Actions/CartAction';

export const getDname = i => {
  if (i?.dname && i?.dname[0]) {
    return i?.dname[0].value;
  }
  return i?.name || 'No Name';
};

const ProductSummary = props => {
  const {
    pdpData,
    addtoCartClinckHandler,
    customModGrps = {},
    modifiedPrice,
    categoryId,
    isIpad,
    comboData,
    categoryName,
    categoryUrl,
  } = props;
  const { id: cardId, additionalProperties = {}, customizable = false, availability, modgrps } = pdpData || {};
  const { ITEM_QUANTITY } = MENU_CONSTANT;
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const { EXPAND_ACCORDIAN, IS_OUT_OF_STOCK, IS_IN_STOCK } = MENU_PDP_PAGE_CONSTANTS;

  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [isActive, setIsActive] = useState();
  const [prodQuantity, setProdQuantity] = useState(1);
  const [itemStatus, setItemStatus] = useState(IS_IN_STOCK);
  const dispatch = useDispatch();
  const tenantData = useSelector(data => data.tenantReducer);
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData = {} } = cartReducer || {};
  const { web: { global: { showPriceWithTax = false } = {} } = {} } = tenantData?.componentOptions ?? {};

  const { veg } = additionalProperties;

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    pdpScreenCommons: { currentAccordian },
  } = userOrderState;

  useEffect(() => {
    if (getAndCheck(customModGrps?.length, modgrps?.length)) {
      setIsActive(modgrps[0].id);
    }
  }, [customModGrps, modgrps]);

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const setAsActiveLink = (e, id) => {
    if (itemStatus === IS_OUT_OF_STOCK) {
      return false;
    }
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    userOrderStateDispatch({ type: EXPAND_ACCORDIAN, value: id });
    const btnElm = document.getElementById('accordion-' + id);
    btnElm?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    setIsActive(id);
  };

  useEffect(() => {
    return () => {
      userOrderStateDispatch({ type: EXPAND_ACCORDIAN, value: '' });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentAccordian) {
      setAsActiveLink(null, currentAccordian);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccordian]);

  const makeItComboHandler = e => {
    if (itemStatus === IS_OUT_OF_STOCK) {
      return false;
    }
    e.preventDefault();
  };
  const onAddtoCartClinckHandler = async e => {
    e.preventDefault();
    if (!userParams.localized) {
      addtoCartClinckHandler();
    } else {
      let modGroups = getTernaryValue(customizable, customModGrps, []);
      await dispatch(
        addItemToCartAction(
          {
            params: {
              basketId: cartData.id,
            },
            tenantId: tenantData?.tenantId,
          },
          [
            {
              Id: cardId,
              categoryId: categoryId,
              quantity: prodQuantity,
              modGrps: modGroups,
              categoryName,
              categoryUrl,
            },
          ],
        ),
      );
      setProdQuantity(1);
    }
  };

  const quantityUpdate = (item, type, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (type === QUANTITY_ACTION.Decrease && prodQuantity > 1) {
      setProdQuantity(prodQuantity - 1);
    }
    if (type === QUANTITY_ACTION.Increase) {
      setProdQuantity(prodQuantity + 1);
    }
  };

  const computePrice = (price, pricewithouttax) => {
    let getprice;
    if (isEmptyObject(price)) {
      getprice = getPriceBasedOnShowPriceWithTaxFlag(
        price,
        pricewithouttax,
        tenantData?.currencyConversionFactor,
        showPriceWithTax,
      );
    }
    if (customizable) {
      getprice = price;
    } else if (getprice === 0) {
      setItemStatus(IS_OUT_OF_STOCK);
      return translateWithI18Next('outOfStock');
    }
    let totalPrice = prodQuantity * getprice;
    return `${tenantData?.currencySymbol} ${Math.round(totalPrice * 100) / 100}`;
  };

  const quantityUpdateTemplate = () => {
    return (
      <div
        className={`quantityAddtocart qty-calc mg-set ${
          prodQuantity ? 'cardwithQuantity ' + userParams.loggedIn : 'cardwithNoquantity'
        }`}
      >
        <QuantityModifier
          itemCount={prodQuantity}
          itemQuantity={ITEM_QUANTITY}
          updateItemQuantity={quantityUpdate}
          quantityAction={QUANTITY_ACTION}
          item={undefined}
          itemName={getDname(pdpData)}
          maxItemCountPerLineItem={tenantData?.maxItemCountPerLineItem}
          cartItemCount={1}
          hideChild={true}
        />
      </div>
    );
  };

  const addToCartTemplate = () => {
    return (
      <ButtonComp
        tabIndex='1'
        className='button redButton pdp-cart-button'
        data-testid='add-to-cart-handler'
        onClick={e => onAddtoCartClinckHandler(e)}
        disabled={itemStatus === IS_OUT_OF_STOCK}
      >
        {itemStatus === IS_OUT_OF_STOCK ? (
          <span className='outofstock'>{translateWithI18Next('outOfStock')}</span>
        ) : (
          <>
            <span>{translateWithI18Next('addToCart')}</span>
            {availability && availability.length && (
              <span>
                {getTernaryValue(
                  customizable,
                  computePrice(modifiedPrice),
                  computePrice(availability[0], additionalProperties?.pricewithouttax),
                )}
              </span>
            )}
          </>
        )}
      </ButtonComp>
    );
  };

  return isEmptyObject(pdpData) ? (
    <PdpSummaryViewComponent
      data-testid='pdp-summary-view'
      pdpData={pdpData}
      getDname={getDname}
      veg={veg}
      Non_veg_dot_Icon={Non_veg_dot_Icon}
      Veg_dot_Icon={Veg_dot_Icon}
      modgrps={modgrps}
      customizable={customizable}
      isActive={isActive}
      itemStatus={itemStatus}
      IS_OUT_OF_STOCK={IS_OUT_OF_STOCK}
      setAsActiveLink={setAsActiveLink}
      PDPEditIconDisabled={PDPEditIconDisabled}
      PDPEditIcon={PDPEditIcon}
      isMobile={isMobile}
      isIpad={isIpad}
      quantityUpdateTemplate={quantityUpdateTemplate}
      addToCartTemplate={addToCartTemplate}
      makeItComboHandler={makeItComboHandler}
      comboData={comboData}
    />
  ) : (
    <div className='d-flex justify-content-center'>{translateWithI18Next('turnedNoResult')}</div>
  );
};

export default ProductSummary;
